import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { setReadNum, getReadNumNormal, getReadNumWeight } from '@src/services/api';

class ReadNum extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        readNum: 0,
    };

    moreTenThousands = (num) => {
        if (!num) return num;

        const numData = Number(num);

        return numData > 9999 ? `${Math.floor(numData / 1000) / 10}万` : num;
    };

    async componentDidMount() {
        const {
            hasOpen,
            copyrightSwitch,
            hasWeight,
            base62Id,
            hasCopyRight,
            createTime,
            searchPath = '',
            searchPathFilter = '',
        } = this.props.content;
        let readNum = 0;

        if (hasOpen === '1') {
            try {
                let publishTime = createTime.replace(/-/g, '/');
                let serviceid = 5;
                const searchPathArray = (searchPath && searchPath?.split?.(',')) || [];
                const searchPathFilterArray = (searchPathFilter && searchPathFilter?.split?.(',')) || [];

                if (searchPathArray.length > 0 && searchPathFilterArray.length > 0) {
                    let flag = false;

                    searchPathFilterArray.forEach((filterItem) => {
                        searchPathArray.forEach((articleItem) => {
                            if (articleItem.indexOf(filterItem) === 0) {
                                flag = true;
                            }
                        });
                    });

                    if (flag) {
                        serviceid = 6;
                    }
                }

                publishTime = new Date(publishTime).getTime() || new Date().getTime();
                publishTime = Math.floor(publishTime / 1000);
                await setReadNum(base62Id, publishTime);

                if (hasWeight === '1') {
                    readNum = await getReadNumNormal(base62Id, publishTime, serviceid);
                } else {
                    readNum = await getReadNumWeight(base62Id, publishTime, serviceid);
                }

                if ((copyrightSwitch === '2' && !hasCopyRight) || (copyrightSwitch === '3' && hasCopyRight)) {
                    readNum = 0;
                }

                this.setState({
                    readNum: this.moreTenThousands(readNum),
                });
            } catch (e) {
                console.log(e, 'readNum error');
            }
        }
    }

    render() {
        const { readNum } = this.state;
        const { articleSubText } = this.props.content;

        return readNum ? (
            <div className={styles.readNum}>
                {readNum}
                {articleSubText}
            </div>
        ) : null;
    }
}

export default errorBoundary(ReadNum);
